module.exports = __webpack_public_path__ + "img/bg-profile.5009213f.png";